<template>
  <div v-if="isPerformedInitialSetup">
    <div class="dashboard-page">
      <DashboardWrapper v-if="isUserCanViewDashboard"/>
      <div v-else>
        <span class="permissions-warning">{{ noAccessMessage }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { isValidDashboardUser } from '../../services/dashboard/userService';
import overlayMixin from '../../mixins/loadingOverlay';
import DashboardWrapper from './DashboardWrapper.vue';

export default {
  mixins: [ overlayMixin ],
  data() {
    return {
      isPerformedInitialSetup: false,
    };
  },
  components: {
    DashboardWrapper,
  },
  async mounted() {
    if (!this.isLoadingOverlayVisible) {
      this.showLoadingOverlay('Loading Dashboard');
    }

    const token = await this.$auth.getTokenSilently();

    await this.$store.dispatch('setInitialDashboardData', { token });

    this.isPerformedInitialSetup = true;

    if (this.isLoadingOverlayVisible) {
      this.hideLoadingOverlay();
    }
  },
  computed: {
    ...mapState({
      isLoadingOverlayVisible: state => state.main.loadingOverlayVisible,
      portfolioBrands: state => state.dashboard.portfolioBrands,
      user: state => state.main.currentUser,
    }),
    noAccessMessage() {
      if (this.isUserCanViewDashboard) {
        return '';
      }

      const message = this.userHasAvailableBrands
        ? 'does not have permission to view reports'
        : 'is not associated with any brands in our system';

      return `User email ${this.userEmail} ${message}. ` +
        'Please contact your CSM for assistance.';
    },
    isUserCanViewDashboard() {
      return this.isValidUser && this.userHasAvailableBrands;
    },
    userHasAvailableBrands() {
      return this.portfolioBrands && this.portfolioBrands.length > 0;
    },
    userEmail() {
      return this.isValidUser ? this.user.email : '';
    },
    isValidUser() {
      return isValidDashboardUser(this.user);
    },
  },
};
</script>
<style scoped>
.permissions-warning {
  display: block;
  width: 80%;
  margin: 32px auto;
  font-size: 13px;
  font-family: "Work Sans", sans-serif;
  line-height: 26px;
  color: #c16868;
  background: #ffdcdc;
  border-radius: 2px;
}
</style>
